import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

// Componentes
import { TarjetaNumericaComponent } from './components/tarjeta-numerica/tarjeta-numerica.component';
import { TarjetaMetricaReporteComponent } from './components/tarjeta-metrica-reporte/tarjeta-metrica-reporte.component';
import { GraficoEvolucionVisitasComponent } from './components/grafico-evolucion-visitas/grafico-evolucion-visitas.component';
import { GraficoEstadoPlanesComponent } from './components/grafico-estado-planes/grafico-estado-planes.component';
import { GraficoAvanceVisitasComponent } from './components/grafico-avance-visitas/grafico-avance-visitas.component';
import { TarjetaVisitasComponent } from './components/tarjeta-visitas/tarjeta-visitas.component';
import { MapaUbicacionVisitasComponent } from './components/mapa-ubicacion-visitas/mapa-ubicacion-visitas.component';
import { FormularioVisitaComponent } from './components/formulario-visita/formulario-visita.component';
import { FormularioVisitaOfflineComponent } from './components/formulario-visita-offline/formulario-visita-offline.component';
import { PanelAccionHojaRutaComponent } from './components/panel-accion-hoja-ruta/panel-accion-hoja-ruta.component';
import { FormularioRegistrarVisitaOfflineComponent } from './components/formulario-registrar-visita-offline/formulario-registrar-visita-offline.component';
import { SelectorObjetivosVisitaRegistroComponent } from './components/selector-objetivos-visita-registro/selector-objetivos-visita-registro.component';
import { TarjetaGestionComponent } from './components/tarjeta-gestion/tarjeta-gestion.component';
import { TarjetaSolicitudesPendientesComponent } from './components/tarjeta-solicitudes-pendientes/tarjeta-solicitudes-pendientes.component';
import { FormularioActividadGrupalComponent } from './components/formulario-actividad-grupal/formulario-actividad-grupal.component';
import { DetalleActividadGrupalComponent } from './components/detalle-actividad-grupal/detalle-actividad-grupal.component';
import { FormularioAsistenciaActividadGrupalComponent } from './components/formulario-asistencia-actividad-grupal/formulario-asistencia-actividad-grupal.component';
import { FormularioResumenFirmadoVisitaComponent } from './components/formulario-resumen-firmado-visita/formulario-resumen-firmado-visita.component';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { EnlacesLegalesComponent } from './components/enlaces-legales/enlaces-legales.component';
import { GraficoDonaComponent } from './components/grafico-dona/grafico-dona.component';
import { GraficoFullscreenTablaComponent } from './components/grafico-fullscreen-tabla/grafico-fullscreen-tabla.component';
import { PlanNegocioPdfComponent } from './components/plan-negocio-pdf/plan-negocio-pdf.component';
import { MargenBrutoPdfComponent } from './components/margen-bruto-pdf/margen-bruto-pdf.component';
import { ResumenVisitaPdfComponent } from './components/resumen-visita-pdf/resumen-visita-pdf.component';
import { ChileanNumberPipe } from './pipes/chilean-number.pipe';

@NgModule({
  declarations: [
    TarjetaNumericaComponent,
    TarjetaMetricaReporteComponent,
    GraficoEvolucionVisitasComponent,
    GraficoEstadoPlanesComponent,
    GraficoAvanceVisitasComponent,
    TarjetaVisitasComponent,
    MapaUbicacionVisitasComponent,
    FormularioVisitaComponent,
    FormularioVisitaOfflineComponent,
    PanelAccionHojaRutaComponent,
    FormularioRegistrarVisitaOfflineComponent,
    SelectorObjetivosVisitaRegistroComponent,
    TarjetaGestionComponent,
    TarjetaSolicitudesPendientesComponent,
    FormularioActividadGrupalComponent,
    DetalleActividadGrupalComponent,
    FormularioAsistenciaActividadGrupalComponent,
    FormularioResumenFirmadoVisitaComponent,
    AppFooterComponent,
    EnlacesLegalesComponent,
    GraficoDonaComponent,
    GraficoFullscreenTablaComponent,
    PlanNegocioPdfComponent,
    MargenBrutoPdfComponent,
    ResumenVisitaPdfComponent,
    ChileanNumberPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ReactiveFormsModule,
    RouterModule,
    IonicModule
  ],
  exports: [
    TarjetaNumericaComponent,
    TarjetaMetricaReporteComponent,
    GraficoEvolucionVisitasComponent,
    GraficoEstadoPlanesComponent,
    GraficoAvanceVisitasComponent,
    TarjetaVisitasComponent,
    MapaUbicacionVisitasComponent,
    FormularioVisitaComponent,
    FormularioVisitaOfflineComponent,
    PanelAccionHojaRutaComponent,
    FormularioRegistrarVisitaOfflineComponent,
    SelectorObjetivosVisitaRegistroComponent,
    TarjetaGestionComponent,
    TarjetaSolicitudesPendientesComponent,
    FormularioActividadGrupalComponent,
    DetalleActividadGrupalComponent,
    FormularioAsistenciaActividadGrupalComponent,
    FormularioResumenFirmadoVisitaComponent,
    AppFooterComponent,
    EnlacesLegalesComponent,
    GraficoDonaComponent,
    GraficoFullscreenTablaComponent,
    PlanNegocioPdfComponent,
    MargenBrutoPdfComponent,
    ResumenVisitaPdfComponent,
    ChileanNumberPipe
  ]
})
export class SharedModule { }
